import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "* {\r\n  font-family: arial;\r\n  box-sizing: border-box;\r\n  transition: all 0.5 ease;\r\n}\r\n.as-slider-container {\r\n  position: relative;\r\n  background: #efefef;\r\n  overflow: hidden;\r\n}\r\n.as-slider {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  background: #ccc;\r\n}\r\n.as-sliderImage {\r\n  display: block;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.as-sliderImage img {\r\n  width: 100%;\r\n  display: block;\r\n  margin: 0;\r\n}\r\nul.slider-items {\r\n  list-style: none;\r\n  padding: 0;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  position: absolute;\r\n  overflow: hidden;\r\n}\r\n.item {\r\n  flex: 1 1;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  position: relative;\r\n  margin: 0 1px;\r\n  display: none;\r\n  box-sizing: border-box;\r\n  padding: 5px 5px 25px;\r\n  cursor: default;\r\n}\r\nli.item.active {\r\n  color: #fff;\r\n}\r\n.hide {\r\n  display: none;\r\n}\r\n.showitem {\r\n  display: flex;\r\n  align-items: flex-end;\r\n}\r\n.as-slider-navlink .link {\r\n  background: #6f6f6f66;\r\n  border: 0;\r\n  color: #fff;\r\n  padding: 5px;\r\n  position: absolute;\r\n  top: 50%;\r\n  min-height: 70px;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n}\r\nbutton.link.nextSlide {\r\n  right: 0;\r\n}\r\n.item-data {\r\n  overflow: hidden;\r\n  color: #fff;\r\n  width: calc(100% - 20px);\r\n  display: block;\r\n  box-sizing: border-box;\r\n  cursor: default;\r\n  margin: 0 auto;\r\n  transition: all 1.5s ease;\r\n  transform: translateY(20%);\r\n}\r\n.item-data a {\r\n  text-decoration: none;\r\n  color: #fff;\r\n}\r\n.item-data h4 {\r\n  margin: 0;\r\n  width: 100%;\r\n}\r\n.item-data p {\r\n  margin-bottom: 0;\r\n  display: none;\r\n  max-height: 270px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.item-data:hover,\r\n.active .item-data {\r\n  transform: translateY(0);\r\n}\r\n.item-data:hover p,\r\n.active .item-data p {\r\n  display: block;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .item-data p {\r\n    max-height: 180px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 550px) {\r\n  .item-data p {\r\n    max-height: 54px;\r\n  }\r\n}\r\n";
styleInject(css);

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var Slider = function Slider(_ref) {
  var collection = _ref.collection,
      start = _ref.start,
      end = _ref.end,
      dataSet = _ref.dataSet,
      option = _ref.option,
      interval = _ref.interval,
      charLimit = _ref.charLimit,
      wrapClassName = _ref.wrapClassName;

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      items = _useState2[0],
      setItem = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = slicedToArray(_useState3, 2),
      sliderImages = _useState4[0],
      setSliderImages = _useState4[1];

  var timeInterval = 0;

  useEffect(function () {
    if (dataSet.length > 0) {
      var itemsVal = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + ' .slider-items li');
      var SliderImage = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + ' .as-sliderImage img');
      setItem(itemsVal);
      setSliderImages(SliderImage);
    }
  }, [dataSet]);

  var TimerInterval = function TimerInterval(val) {
    if (timeInterval === interval) {
      timeInterval = 0;
      nextSlide();
    } else timeInterval++;
  };

  useEffect(function () {
    if (items.length > 0 && sliderImages.length > 0) {
      window.addEventListener('resize', setNoOfSlide());
      document.getElementsByClassName('nextSlide')[0].addEventListener('click', nextSlide);
      document.getElementsByClassName('prevSlide')[0].addEventListener('click', prevSlide);
      for (var i = 0; i < items.length; i++) {
        items[i].addEventListener('mouseover', hoverFunction);
      }
      setInterval(function () {
        return TimerInterval();
      }, 1000);
    }
    return function () {
      window.removeEventListener('resize', setNoOfSlide());
      for (var _i = 0; _i < items.length; _i++) {
        items[_i].removeEventListener('mouseover', hoverFunction);
      }
      document.getElementsByClassName('nextSlide')[0].removeEventListener('click', nextSlide);
      document.getElementsByClassName('prevSlide')[0].removeEventListener('click', prevSlide);
    };
  }, [items, sliderImages]);

  var setNoOfSlide = function setNoOfSlide() {
    if (window.innerWidth > 1200) {
      collection = option.responsive.lg;
    }
    if (window.innerWidth > 992 && window.innerWidth < 1200) {
      collection = option.responsive.md;
    }
    if (window.innerWidth > 576 && window.innerWidth < 992) {
      collection = option.responsive.sm;
    }
    if (window.innerWidth < 576) {
      collection = 1;
    }

    start = 0;
    end = collection;
    if (items.length > 0) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('active');
      }
      items[0].classList.add('active');
    }
    if (sliderImages.length > 0) {
      sliderImages[0].setAttribute('src', items[items.length - 1].dataset.url);
    }

    hideShowItems();
  };

  var nextSlide = function nextSlide() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + ' .item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index - 1);
      items[indexVal].classList.remove('active');
      if (indexVal === items.length - 1) {
        items[0].classList.add('active');
        sliderImages[0].setAttribute('src', items[0].dataset.url);
      } else {
        items[indexVal + 1].classList.add('active');
        sliderImages[0].setAttribute('src', items[indexVal + 1].dataset.url);
      }
      timeInterval = 0;
      hideShowItems();
    }
  };

  var hoverFunction = function hoverFunction(e) {
    if (e.target && e.target.matches('li.item')) {
      sliderImages[0].setAttribute('src', e.target.dataset.url);
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('active');
      }
      e.target.classList.add('active');
      timeInterval = 0;
    }
  };

  var prevSlide = function prevSlide() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + ' .item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index) - 1;
      items[indexVal].classList.remove('active');
      if (indexVal === 0) {
        items[items.length - 1].classList.add('active');
        sliderImages[0].setAttribute('src', items[items.length - 1].dataset.url);
      } else {
        items[indexVal - 1].classList.add('active');
        sliderImages[0].setAttribute('src', items[indexVal - 1].dataset.url);
      }
      timeInterval = 0;
      hideShowItems();
    }
  };

  var hideShowItems = function hideShowItems() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + ' .item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index) - 1;
      if (indexVal >= end) {
        start++;
        end++;
      }
      if (indexVal === 0) {
        start = 0;
        end = collection;
      }
      if (indexVal < start) {
        start--;
        end--;
      }
      if (indexVal === items.length - 1) {
        start = items.length - collection;
        end = items.length;
      }
      for (var i = 0; i < items.length; i++) {
        if (i < end && i >= start) {
          items[i].classList.add('showitem');
        } else {
          items[i].classList.remove('showitem');
        }
      }
    }
  };

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'div',
      { className: wrapClassName + ' as-slider-container' },
      React.createElement(
        'div',
        { className: 'as-slider' },
        React.createElement(
          'div',
          { className: 'as-sliderImage' },
          React.createElement('img', { src: '' })
        ),
        React.createElement(
          'ul',
          { className: 'slider-items' },
          dataSet.map(function (item, index) {
            return React.createElement(
              'li',
              { className: 'item', 'data-index': index + 1, 'data-url': item.imageUrl, key: index },
              React.createElement(
                'div',
                { className: 'item-data' },
                React.createElement(
                  'h4',
                  null,
                  React.createElement(
                    'a',
                    { href: item.url },
                    item.title
                  )
                ),
                React.createElement(
                  'p',
                  null,
                  item.description.substring(0, charLimit),
                  ' ',
                  item.description.length > charLimit ? '...' : ''
                )
              )
            );
          })
        )
      ),
      React.createElement(
        'div',
        { className: 'as-slider-navlink' },
        React.createElement(
          'button',
          { className: 'link prevSlide' },
          'Prev'
        ),
        React.createElement(
          'button',
          { className: 'link nextSlide' },
          'Next'
        )
      )
    )
  );
};

Slider.propTypes = {
  collection: PropTypes.number,
  start: PropTypes.number,
  end: PropTypes.number,
  dataSet: PropTypes.array.isRequired,
  interval: PropTypes.number,
  charLimit: PropTypes.number,
  wrapClassName: PropTypes.string,
  option: PropTypes.object
};

Slider.defaultProps = {
  collection: 5,
  start: null,
  end: null,
  interval: 5,
  charLimit: 120,
  wrapClassName: '',
  option: {
    responsive: {
      lg: 6,
      md: 5,
      sm: 3
    },
    charLimit: 100
  }
};

var css$1 = "body {\r\n  margin: 0;\r\n}\r\n* {\r\n  font-family: inherit;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n}\r\n.as-slider-sm {\r\n  margin-bottom: 10px;\r\n  max-width: 450px;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n.slider-items {\r\n  padding: 0;\r\n}\r\nimg {\r\n  width: 100%;\r\n  height: auto;\r\n  display: block;\r\n}\r\n.sliderSm-items {\r\n  margin: 0;\r\n}\r\n.as-slider-sm .item {\r\n  display: flex;\r\n  box-shadow: -2px 2px 3px #999;\r\n  position: relative;\r\n  align-items: center;\r\n  border-radius: 15px;\r\n  min-height: 190px;\r\n  background: linear-gradient(-26deg, #4b00ff, #fb00ff);\r\n  color: #fff;\r\n  display: none;\r\n}\r\n\r\n.as-slider-sm .active {\r\n  display: flex;\r\n}\r\n.as-slider-sm .item img {\r\n  width: 140px;\r\n  height: auto;\r\n  position: absolute;\r\n  height: 140px;\r\n  transform: translate(-40px, -50%);\r\n  border-radius: 15px;\r\n  top: 50%;\r\n  box-shadow: -4px 4px 20px white;\r\n}\r\n.as-slider-sm .item-data {\r\n  padding: 10px 30px 10px 120px;\r\n}\r\n.dots-box {\r\n  position: absolute;\r\n  padding: 0;\r\n  margin: 0;\r\n  top: 0;\r\n  right: 0;\r\n  height: 100%;\r\n  width: 25px;\r\n  color: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.dots-position {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.dots-position li {\r\n  width: 8px;\r\n  height: 8px;\r\n  list-style: none;\r\n  background: #fff;\r\n  margin: 6px 0;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: none;\r\n}\r\n.dots-position .showitem {\r\n  display: block;\r\n}\r\n.dots-position li.active {\r\n  height: 20px;\r\n  background: #f551fb;\r\n  display: block;\r\n}\r\n\r\n.item-data h4 {\r\n  margin: 10px 0;\r\n}\r\n.item-data p {\r\n  margin: 0;\r\n}\r\n\r\n.as-slider-navlink-sm {\r\n  position: absolute;\r\n  bottom: 5px;\r\n  right: 10px;\r\n  color: #fff;\r\n}\r\n.as-slider-navlink-sm button {\r\n  background: none;\r\n  border: 0;\r\n  color: #fff;\r\n  font-size: 21px;\r\n  padding: 2px;\r\n  cursor: pointer;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .as-slider-sm {\r\n    overflow: visible;\r\n    margin: 6rem 0 0;\r\n  }\r\n  .sliderSm-items {\r\n    padding: 0;\r\n  }\r\n  .as-slider-sm .item {\r\n    flex-direction: column;\r\n  }\r\n  .as-slider-sm .item img {\r\n    top: 0;\r\n    left: 15px;\r\n    transform: translate(0, -50%);\r\n  }\r\n  .as-slider-sm .item-data {\r\n    padding: 5rem 15px 10px;\r\n  }\r\n}\r\n";
styleInject(css$1);

var SliderSm = function SliderSm(_ref) {
  var collection = _ref.collection,
      start = _ref.start,
      end = _ref.end,
      dataSet = _ref.dataSet,
      interval = _ref.interval,
      charLimit = _ref.charLimit,
      wrapClassName = _ref.wrapClassName;

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      items = _useState2[0],
      setItem = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = slicedToArray(_useState3, 2),
      dots = _useState4[0],
      setDots = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = slicedToArray(_useState5, 2),
      index = _useState6[0],
      setIndexval = _useState6[1];

  var timeInterval = 0;

  useEffect(function () {
    if (dataSet.length > 0) {
      var itemsVal = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + '.as-slider-sm .sliderSm-items li');
      var dotsVal = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + ' .dots-position li');
      setItem(itemsVal);
      setDots(dotsVal);
    }
  }, [dataSet]);

  var TimerInterval = function TimerInterval(val) {
    if (timeInterval === interval) {
      timeInterval = 0;
      nextSlide();
    } else timeInterval++;
  };

  useEffect(function () {
    if (items.length > 0 && dots.length > 0) {
      window.addEventListener('resize', setNoOfSlide());
      document.getElementsByClassName('nextSlideSm')[0].addEventListener('click', nextSlide);
      document.getElementsByClassName('prevSlideSm')[0].addEventListener('click', prevSlide);
      for (var i = 0; i < dots.length; i++) {
        dots[i].addEventListener('click', ClickFunction);
      }
      setInterval(function () {
        return TimerInterval();
      }, 1000);
    }
    return function () {
      window.removeEventListener('resize', setNoOfSlide());
      document.getElementsByClassName('nextSlideSm')[0].removeEventListener('click', nextSlide);
      document.getElementsByClassName('prevSlideSm')[0].removeEventListener('click', prevSlide);
      for (var _i = 0; _i < dots.length; _i++) {
        dots[_i].removeEventListener('click', ClickFunction);
      }
    };
  }, [items, dots]);

  var setNoOfSlide = function setNoOfSlide() {
    start = 0;
    end = collection;
    if (items.length > 0) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('active');
        dots[i].classList.remove('active');
      }
      items[0].classList.add('active');
      dots[0].classList.add('active');
    }
    hideShowItems();
  };

  var nextSlide = function nextSlide() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + '.as-slider-sm .item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index);
      items[indexVal].classList.remove('active');
      dots[indexVal].classList.remove('active');

      if (indexVal === items.length - 1) {
        items[0].classList.add('active');
        dots[0].classList.add('active');
        setIndexval(1);
      } else {
        items[indexVal + 1].classList.add('active');
        dots[indexVal + 1].classList.add('active');
        setIndexval(indexVal + 2);
      }
      timeInterval = 0;
      hideShowItems();
    }
  };

  var prevSlide = function prevSlide() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + '.as-slider-sm .item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index);
      items[indexVal].classList.remove('active');
      dots[indexVal].classList.remove('active');
      if (indexVal === 0) {
        items[items.length - 1].classList.add('active');
        dots[items.length - 1].classList.add('active');
        setIndexval(items.length);
      } else {
        items[indexVal - 1].classList.add('active');
        dots[indexVal - 1].classList.add('active');
        setIndexval(indexVal);
      }
      timeInterval = 0;
      hideShowItems();
    }
  };

  var ClickFunction = function ClickFunction(e) {
    if (e && e.target && e.target.matches('li')) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('active');
        dots[i].classList.remove('active');
      }
      items[e.target.dataset.index].classList.add('active');
      dots[e.target.dataset.index].classList.add('active');
      e.target.classList.add('active');
      timeInterval = 0;
      setIndexval(parseInt(e.target.dataset.index) + 1);
    }
  };

  var hideShowItems = function hideShowItems() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + '.as-slider-sm .item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index);
      if (indexVal >= end) {
        start++;
        end++;
      }
      if (indexVal === 0) {
        start = 0;
        end = collection;
      }
      if (indexVal < start) {
        start--;
        end--;
      }
      if (indexVal === dots.length - 1) {
        start = dots.length - collection;
        end = dots.length;
      }
      for (var i = 0; i < dots.length; i++) {
        if (i < end && i >= start) {
          dots[i].classList.add('showitem');
        } else {
          dots[i].classList.remove('showitem');
        }
      }
    }
  };

  return React.createElement(
    'div',
    { className: wrapClassName + ' as-slider-sm' },
    React.createElement(
      'ul',
      { className: 'sliderSm-items' },
      dataSet.map(function (item, index) {
        return React.createElement(
          'li',
          { className: 'item', 'data-index': index, key: index },
          React.createElement('img', { src: item.imageUrl, alt: 'img' + index }),
          React.createElement(
            'div',
            { className: 'item-data' },
            React.createElement(
              'small',
              null,
              item.date
            ),
            React.createElement(
              'h4',
              null,
              React.createElement(
                'a',
                { href: item.url },
                item.title
              )
            ),
            React.createElement(
              'p',
              null,
              item.description.substring(0, charLimit),
              ' ',
              item.description.length > charLimit ? '...' : ''
            )
          )
        );
      })
    ),
    React.createElement(
      'div',
      { className: 'dots-box' },
      React.createElement(
        'ul',
        { className: 'dots-position' },
        dataSet.map(function (item, index) {
          return React.createElement('li', { 'data-index': index, key: index });
        })
      )
    ),
    React.createElement(
      'div',
      { className: 'as-slider-navlink-sm' },
      React.createElement(
        'small',
        null,
        index + '/' + dataSet.length,
        ' '
      ),
      React.createElement(
        'button',
        { className: 'link prevSlideSm' },
        '\u2190'
      ),
      React.createElement(
        'button',
        { className: 'link nextSlideSm' },
        '\u2192'
      )
    )
  );
};

SliderSm.propTypes = {
  collection: PropTypes.number,
  start: PropTypes.number,
  end: PropTypes.number,
  dataSet: PropTypes.array.isRequired,
  interval: PropTypes.number,
  charLimit: PropTypes.number,
  wrapClassName: PropTypes.string
};

SliderSm.defaultProps = {
  collection: 5,
  start: null,
  end: null,
  interval: 5,
  charLimit: 120,
  wrapClassName: ''
};

var css$2 = ".as-single-prod-slider {\r\n  width: 100%;\r\n  max-width: 350px;\r\n  display: block;\r\n  /* background-color: rgb(129, 158, 148); */\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n.as-single-prod-slider ul {\r\n  padding: 0;\r\n}\r\n.as-single-prod-slider img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n.as-single-prod-slider .slider-item {\r\n  width: 100%;\r\n  display: none;\r\n  filter: drop-shadow(0 5px 10px #44444494);\r\n  border-radius: 26px 26px 0 0;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n  position: absolute;\r\n  color: #fff;\r\n  background-color: #ff9800;\r\n}\r\n.as-single-prod-slider .slider-item.active {\r\n  display: block;\r\n  position: relative;\r\n}\r\n\r\n.slide-image {\r\n  position: relative;\r\n  margin: 1rem auto;\r\n  text-align: center;\r\n  filter: drop-shadow(0px 18px 10px #0000008a);\r\n}\r\n\r\n.description {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.brand-logo {\r\n  max-width: 82px;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 100%;\r\n  z-index: 2;\r\n  max-height: 49px;\r\n  padding-right: 14px;\r\n  box-sizing: border-box;\r\n}\r\n.upper-section {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n.upper-section .price {\r\n  font-size: 2.2rem;\r\n}\r\n.upper-section .price del {\r\n  font-size: 1rem;\r\n  opacity: 0.7;\r\n}\r\n.upper-section .title {\r\n  font-size: 1.15rem;\r\n}\r\n.description p {\r\n  font-size: 0.8rem;\r\n}\r\n.description p a {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  opacity: 0.7;\r\n}\r\n.description p a:hover {\r\n  opacity: 1;\r\n}\r\n.brand-logo p {\r\n  color: inherit;\r\n  opacity: 0.5;\r\n  font-weight: bold;\r\n  font-style: italic;\r\n  font-size: 1rem;\r\n}\r\n.shape {\r\n  clip-path: polygon(\r\n    100% 0,\r\n    0 0,\r\n    0.2% 23.7%,\r\n    0.5% 33.1%,\r\n    1.5% 42.5%,\r\n    2.5% 47%,\r\n    3.5% 51.5%,\r\n    4.5% 54%,\r\n    5.5% 56%,\r\n    6.5% 57.1%,\r\n    7.5% 57.8%,\r\n    8.5% 57.7%,\r\n    9.5% 57.5%,\r\n    10.5% 56.7%,\r\n    11.5% 54.9%,\r\n    12.5% 53.3%,\r\n    15.5% 46.7%,\r\n    18.5% 37.8%,\r\n    23.5% 25.9%,\r\n    26% 21.6%,\r\n    29% 16.9%,\r\n    31.5% 14.5%,\r\n    33.5% 12.6%,\r\n    35% 11.8%,\r\n    38% 10.5%,\r\n    42% 11%,\r\n    45% 13.2%,\r\n    48% 17.3%,\r\n    52% 26%,\r\n    58% 38%,\r\n    62% 46%,\r\n    65% 51%,\r\n    68.5% 53.7%,\r\n    71% 55.2%,\r\n    73% 56%,\r\n    76% 57.2%,\r\n    79% 57.8%,\r\n    82% 57.8%,\r\n    85% 59.3%,\r\n    90% 63.4%,\r\n    92% 66.6%,\r\n    94% 70.5%,\r\n    96% 76.5%,\r\n    98% 86.4%,\r\n    100% 100%\r\n  );\r\n  position: absolute;\r\n  top: calc(100% - 1px);\r\n  left: 0;\r\n  width: 100%;\r\n  height: 91px;\r\n  background-color: inherit;\r\n}\r\n.slide-no {\r\n  height: 40px;\r\n  width: 40px;\r\n  position: absolute;\r\n  top: 100%;\r\n  z-index: 1;\r\n  border: 2px inset;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 50%;\r\n  box-sizing: border-box;\r\n  left: 11px;\r\n  font-size: 12px;\r\n}\r\n\r\n.dots-points {\r\n  display: flex;\r\n  padding: 0;\r\n  justify-content: center;\r\n  margin-top: 70px;\r\n}\r\n\r\n.dots-points li {\r\n  width: 15px;\r\n  height: 6px;\r\n  background: #000;\r\n  margin: 3px;\r\n  list-style: none;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  opacity: 0.4;\r\n  cursor: pointer;\r\n}\r\n.dots-points li.active {\r\n  width: 20px;\r\n  opacity: 1;\r\n}\r\n";
styleInject(css$2);

var SingleProdSlider = function SingleProdSlider(_ref) {
  var collection = _ref.collection,
      start = _ref.start,
      end = _ref.end,
      dataSet = _ref.dataSet,
      interval = _ref.interval,
      charLimit = _ref.charLimit,
      wrapClassName = _ref.wrapClassName;

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      items = _useState2[0],
      setItem = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = slicedToArray(_useState3, 2),
      dots = _useState4[0],
      setDots = _useState4[1];
  // const [index, setIndexval] = useState(1)


  var timeInterval = 0;

  useEffect(function () {
    if (dataSet.length > 0) {
      var itemsVal = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + '.as-single-prod-slider .single-prod-container li');
      var dotsVal = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + ' .dots-points li');
      setItem(itemsVal);
      setDots(dotsVal);
    }
  }, [dataSet]);

  var TimerInterval = function TimerInterval() {
    if (timeInterval === interval) {
      timeInterval = 0;
      nextSlide();
    } else timeInterval++;
  };

  useEffect(function () {
    if (items.length > 0 && dots.length > 0) {
      window.addEventListener('resize', setNoOfSlide());
      // document.getElementsByClassName('nextSlideSm')[0].addEventListener('click', nextSlide)
      // document.getElementsByClassName('prevSlideSm')[0].addEventListener('click', prevSlide)
      for (var i = 0; i < dots.length; i++) {
        dots[i].addEventListener('click', ClickFunction);
      }
      setInterval(function () {
        return TimerInterval();
      }, 1000);
    }
    return function () {
      window.removeEventListener('resize', setNoOfSlide());
      // document.getElementsByClassName('nextSlideSm')[0].removeEventListener('click', nextSlide)
      // document.getElementsByClassName('prevSlideSm')[0].removeEventListener('click', prevSlide)
      for (var _i = 0; _i < dots.length; _i++) {
        dots[_i].removeEventListener('click', ClickFunction);
      }
    };
  }, [items, dots]);

  var setNoOfSlide = function setNoOfSlide() {
    start = 0;
    end = collection;
    if (items.length > 0) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('active');
        dots[i].classList.remove('active');
      }
      items[0].classList.add('active');
      dots[0].classList.add('active');
    }
    hideShowItems();
  };

  var nextSlide = function nextSlide() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + '.as-single-prod-slider .slider-item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index);
      items[indexVal].classList.remove('active');
      dots[indexVal].classList.remove('active');

      if (indexVal === items.length - 1) {
        items[0].classList.add('active');
        dots[0].classList.add('active');
        // setIndexval(1)
      } else {
        items[indexVal + 1].classList.add('active');
        dots[indexVal + 1].classList.add('active');
        // setIndexval(indexVal + 2)
      }
      timeInterval = 0;
      hideShowItems();
    }
  };

  // const prevSlide = () => {
  //   let activeClass = document.querySelectorAll(
  //     `${wrapClassName ? '.' + wrapClassName : ''}.as-multi-slider .slider-item.active`
  //   )
  //   if (activeClass.length > 0) {
  //     let indexVal = parseInt(activeClass[0].dataset.index)
  //     items[indexVal].classList.remove('active')
  //     dots[indexVal].classList.remove('active')
  //     if (indexVal === 0) {
  //       items[items.length - 1].classList.add('active')
  //       dots[items.length - 1].classList.add('active')
  //       setIndexval(items.length)
  //     } else {
  //       items[indexVal - 1].classList.add('active')
  //       dots[indexVal - 1].classList.add('active')
  //       setIndexval(indexVal)
  //     }
  //     timeInterval = 0
  //     hideShowItems()
  //   }
  // }

  var ClickFunction = function ClickFunction(e) {
    if (e && e.target && e.target.matches('li')) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('active');
        dots[i].classList.remove('active');
      }
      items[e.target.dataset.index].classList.add('active');
      dots[e.target.dataset.index].classList.add('active');
      e.target.classList.add('active');
      timeInterval = 0;
      // setIndexval(parseInt(e.target.dataset.index) + 1)
    }
  };

  var hideShowItems = function hideShowItems() {
    var activeClass = document.querySelectorAll((wrapClassName ? '.' + wrapClassName : '') + '.as-single-prod-slider .slider-item.active');
    if (activeClass.length > 0) {
      var indexVal = parseInt(activeClass[0].dataset.index);
      if (indexVal >= end) {
        start++;
        end++;
      }
      if (indexVal === 0) {
        start = 0;
        end = collection;
      }
      if (indexVal < start) {
        start--;
        end--;
      }
      if (indexVal === dots.length - 1) {
        start = dots.length - collection;
        end = dots.length;
      }
      for (var i = 0; i < dots.length; i++) {
        if (i < end && i >= start) {
          dots[i].classList.add('showitem');
        } else {
          dots[i].classList.remove('showitem');
        }
      }
    }
  };

  return React.createElement(
    'div',
    { className: wrapClassName + ' as-single-prod-slider' },
    React.createElement(
      'ul',
      { className: 'single-prod-container' },
      dataSet.map(function (item, indexNo) {
        return React.createElement(
          'li',
          { className: 'slider-item', 'data-index': indexNo, key: indexNo },
          React.createElement(
            'div',
            { className: 'upper-section' },
            React.createElement(
              'div',
              { className: 'price' },
              item.offerPrice,
              ' ',
              React.createElement(
                'del',
                null,
                item.realPrice
              )
            ),
            React.createElement(
              'div',
              { className: 'title' },
              item.offer
            )
          ),
          React.createElement(
            'div',
            { className: 'slide-image' },
            React.createElement(
              'a',
              { href: item.url },
              React.createElement('img', { src: item.imageUrl, alt: 'img' + indexNo })
            )
          ),
          React.createElement(
            'div',
            { className: 'description' },
            React.createElement(
              'p',
              null,
              item.description.substring(0, charLimit),
              ' ',
              item.description.length > charLimit ? React.createElement(
                'span',
                null,
                '... ',
                React.createElement(
                  'a',
                  { href: item.url },
                  'more'
                )
              ) : ''
            ),
            React.createElement(
              'span',
              { className: 'brand-logo' },
              React.createElement(
                'p',
                null,
                item.tag
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'slide-no' },
            indexNo + 1
          ),
          React.createElement('div', { className: 'shape' })
        );
      })
    ),
    React.createElement(
      'ul',
      { className: 'dots-points' },
      dataSet.map(function (_item, index) {
        return React.createElement('li', { 'data-index': index, key: index });
      })
    )
  );
};

SingleProdSlider.propTypes = {
  collection: PropTypes.number,
  start: PropTypes.number,
  end: PropTypes.number,
  dataSet: PropTypes.array.isRequired,
  interval: PropTypes.number,
  charLimit: PropTypes.number,
  wrapClassName: PropTypes.string
};

SingleProdSlider.defaultProps = {
  collection: 5,
  start: null,
  end: null,
  interval: 5,
  charLimit: 120,
  wrapClassName: ''
};

// import React, { Component, Fragment } from 'react'

export { Slider, SliderSm, SingleProdSlider };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 19
// module chunks = 0